import { Badge, Card, CardContent } from '@estac1/ui';
import { Check, CircleAlert } from 'lucide-react';
import { ModulesList } from './modules-list.js';
import type { ClientOverview } from './types.js';

/**
 * Módulos, o que falta configurar e o que deu errado nos últimos 30 dias (#656).
 * Os módulos ligam e desligam daqui (#710).
 */
export const HealthSection = ({ data }: { data: ClientOverview }) => (
  <div className="grid gap-3 md:grid-cols-3">
    <Card>
      <CardContent className="space-y-2 pt-6">
        <p className="text-sm font-medium">Módulos</p>
        <ModulesList data={data} />
      </CardContent>
    </Card>
    <Card>
      <CardContent className="space-y-2 pt-6">
        <p className="text-sm font-medium">Configuração</p>
        <ul className="space-y-1 text-sm">
          {data.setup.map((s) => (
            <li key={s.key} className="flex items-center gap-2">
              {s.done ? (
                <Check className="h-4 w-4 text-success" aria-hidden="true" />
              ) : (
                <CircleAlert className="h-4 w-4 text-warning" aria-hidden="true" />
              )}
              <span className={s.done ? '' : 'font-medium'}>{s.label}</span>
              {!s.done && <span className="text-xs text-muted-fg">falta</span>}
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
    <Card>
      <CardContent className="space-y-2 pt-6">
        <p className="text-sm font-medium">Problemas nos últimos 30 dias</p>
        {data.problems.length === 0 ? (
          <p className="text-sm text-muted-fg">Nada fora do normal.</p>
        ) : (
          <ul className="space-y-1 text-sm">
            {data.problems.map((p) => (
              <li key={p.key} className="flex items-center justify-between gap-2">
                <span>{p.label}</span>
                <Badge variant="danger">{p.count}</Badge>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  </div>
);
